import { Injectable } from '@angular/core';
import { LocalStorageService } from '@core/services/util/local-storage.service';
import { DeviceService } from "@core/services/util/device.service";
import { GtmService } from '@core/services/analytics/gtm.service';

export enum WorkerStatus {
	UNSUPPORTED = 'unsupported',
	CONTROLLED = 'repeat_user',
	SUPPORTED = 'new_user'
};

@Injectable({
  providedIn: 'root'
})
export class ServiceWorkerService {

	hoursPassedSinceLastVisit = 0;

    constructor(
		private localStorage: LocalStorageService,
		private deviveService: DeviceService,
		private gtmService: GtmService
	) { }

	isServiceWorkerUnsupported() {
		return !('serviceWorker' in navigator);
	}

	canSendData(storageKey) {
		const daysGap = this.getLastSentDataInDays(storageKey);
		return (daysGap == null || daysGap > 0);
	}

	getLastSentDataInDays(storageKey) {
		const lastDataSend = this.localStorage.get(storageKey);
		if (!lastDataSend) {
			return null;
		}

		const { date } = lastDataSend;
		return this.getDaysGap(date, new Date());
	}

	canSendWorkerStatusData(currentWorkerStatus) {
		if (!this.canSendData('workerStatus')) {
			return false;
		}
		const lastDataSend = (this.localStorage.get('workerStatus') || {});
		const { status } = lastDataSend;
		if (status !== currentWorkerStatus) {
			return true;
		}
	}

	canSendSiteVisitorFrequencyData() {
		return this.canSendData('SiteVisitorFrequency');
	}

	sendWorkerStatus() {
		let workerStatus;
		if (this.isServiceWorkerUnsupported()) {
			workerStatus = WorkerStatus.UNSUPPORTED;
		} else {
			workerStatus = navigator.serviceWorker.controller ? WorkerStatus.CONTROLLED : WorkerStatus.SUPPORTED;
		}
		if (this.canSendWorkerStatusData(workerStatus)) {
			this.gtmService.logEvent("service_worker_kpi", {
				event_label: "WorkerStatus: " + workerStatus
			});
			this.localStorage.set('workerStatus', {
				status: workerStatus,
				date: new Date()
			});
		}
	}

	sendSiteVisiterFrequencyInDays() {
		let daysGap = this.getLastSentDataInDays('SiteVisitorFrequency');
		if (this.canSendSiteVisitorFrequencyData()) {
			daysGap = (daysGap === null) ? 0 : daysGap;
			this.gtmService.logEvent("service_worker_kpi", {
				event_label: "SiteVisitorFrequency",
				event_value: daysGap
			});

			this.localStorage.set('SiteVisitorFrequency', {
				date: new Date()
			});
		} else if(daysGap === 0) {
			this.gtmService.logEvent("service_worker_kpi", {
				event_label: "RevisitInHrs",
				event_value: this.hoursPassedSinceLastVisit
			});
		}
	}

    sendQuotaUsageEstimate() {
      	if ('storage' in navigator && 'estimate' in navigator.storage) {
			navigator.storage.estimate().then((estimate: any) => {
				const usagePercentage = (estimate.usage / estimate.quota * 100).toFixed(2);
				if (this.canSendData('quotaEstimate')) {
					const device = this.deviveService.isMobile() ? "Mobile" : "Desktop";
					this.gtmService.logEvent("service_worker_kpi", {
						event_label: 'QuotaUsageEstimate: ' + device,
						event_value: Number(usagePercentage)
					});
				}
			});
      	}
    }

	sendServiceWorkerKPIData() {
		try {
			this.sendWorkerStatus();
			this.sendSiteVisiterFrequencyInDays();
			this.sendQuotaUsageEstimate();
		} catch(e) {
			console.log(e);
		}
	}

	getDaysGap(date1, date2) {
		date1 = new Date(date1);
		date2 = new Date(date2);
		const diffTime = Math.abs(date2 - date1);
		const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24)); 
		this.hoursPassedSinceLastVisit = Math.floor(diffTime / (1000 * 60 * 60 * 1)) + 1; 
		return diffDays;
	}
}
